import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mb-4" }
const _hoisted_2 = { class: "col-md-6 col-lg-6 col-xl-6 col-xxl-6" }
const _hoisted_3 = { class: "col-md-6 col-lg-6 col-xl-6 col-xxl-6" }
const _hoisted_4 = { class: "col-md-6 col-lg-6 col-xl-6 col-xxl-6" }
const _hoisted_5 = {
  key: 0,
  class: "row mb-4"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h5", null, "Данные о секциях", -1)
const _hoisted_7 = { class: "col-md-6 col-lg-6 col-xl-6 col-xxl-6" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_ui = _resolveComponent("loader-ui")!
  const _component_input_ui = _resolveComponent("input-ui")!
  const _component_form_group_ui = _resolveComponent("form-group-ui")!
  const _component_select_ui = _resolveComponent("select-ui")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: _ctx.id,
    size: "modal-md",
    title: _ctx.state.title
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "loader",
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["prevent"]))
      }, [
        _createVNode(_component_loader_ui, {
          "is-show": _ctx.state.loader
        }, null, 8, ["is-show"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": _ctx.isLocoNumberExistError ? 'Данный номер уже имеется в депо' : 'Укажите номер локомотива',
              label: "Номер локомотива",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  modelValue: _ctx.state.locoNumber,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.locoNumber) = $event)),
                  "is-invalid": _ctx.state.visibleErrors && (_ctx.isLocoNumberError || _ctx.isLocoNumberExistError),
                  mask: { mask: 'Z*', tokens: { 'Z': { pattern: /[0-9]/ }}},
                  maxlength: 5,
                  placeholder: "Номер локомотива"
                }, null, 8, ["modelValue", "is-invalid"])
              ]),
              _: 1
            }, 8, ["invalid-feedback"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Выберите модель локомотива",
              label: "Модель локомотива",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_select_ui, {
                  "is-invalid": _ctx.state.visibleErrors && _ctx.isLocoModelIdError,
                  "item-key": "model",
                  options: _ctx.locoModels,
                  placeholder: "Модель локомотива",
                  searchable: true,
                  values: [_ctx.state.locoModelId],
                  onOnSelected: _ctx.onLocoModelSelected
                }, null, 8, ["is-invalid", "options", "values", "onOnSelected"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Выберите владельца",
              label: "Владелец",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_select_ui, {
                  "is-invalid": _ctx.state.visibleErrors && _ctx.isContractorIdError,
                  "item-key": "name",
                  options: _ctx.contractors,
                  placeholder: "Владелец",
                  searchable: true,
                  values: [_ctx.state.contractorId],
                  onOnSelected: _ctx.onContractorSelected
                }, null, 8, ["is-invalid", "options", "values", "onOnSelected"])
              ]),
              _: 1
            })
          ])
        ]),
        (_ctx.state.locoSections.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.locoSections, (section, sectionInd) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_form_group_ui, {
                    "invalid-feedback": "Укажите номер секции",
                    label: 'Номер секции ' + (sectionInd + 1),
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_input_ui, {
                        modelValue: _ctx.state.locoSections[sectionInd],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.state.locoSections[sectionInd]) = $event),
                        "is-invalid": _ctx.state.visibleErrors && _ctx.isSectionNumberError(sectionInd),
                        placeholder: 'Номер секции ' + (sectionInd + 1)
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "is-invalid", "placeholder"])
                    ]),
                    _: 2
                  }, 1032, ["label"])
                ]))
              }), 256))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_button_ui, { "button-class": "btn-primary" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.state.btn), 1)
              ]),
              _: 1
            })
          ])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["id", "title"]))
}